<template>
    <div class="row">
        <div class="col-sm-12">
            <div class="form-group">
                <label><strong>Products</strong></label>
                <multiselect
                    v-model="products"
                    :options="pListProducts"
                    :multiple="true"
                    :close-on-select="true"
                    :clear-on-select="true" 
                    :preserve-search="false"
                    placeholder="Choose Products"
                    label="title" 
                    track-by="title">
                </multiselect>
                <input type="hidden" name="products" :value="getProducts()">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['pListProducts', 'pSelectedProduct'],
    data() {
        return {
            products: this.pSelectedProduct,
        };
    },
    methods: {
        getProducts() {
            if (this.products.length == 0)
                return '';
            return JSON.stringify(_.map(this.products, p =>  p.pid));
        }
    }
}
</script>
